import { IsString, ValidateNested, IsDefined } from 'class-validator';
import { Type } from 'class-transformer';
import { BodySizeDto } from './BodySizeDto';

export class BodyTypographyDto {
  @IsDefined()
  @IsString()
  fontFamily!: string;

  @IsDefined()
  @ValidateNested()
  @Type(() => BodySizeDto)
  small!: BodySizeDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => BodySizeDto)
  medium!: BodySizeDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => BodySizeDto)
  large!: BodySizeDto;
}
